export default function Go_Tutorial() {
  return (
    <div>
      <h1>Go_Tutorial </h1>
      <p>Go Tutorial</p>
    </div>
  );
}
